import { render, staticRenderFns } from "./BpmBizTaskDealModal.vue?vue&type=template&id=32cf45b5&scoped=true&"
import script from "./BpmBizTaskDealModal.vue?vue&type=script&lang=js&"
export * from "./BpmBizTaskDealModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmBizTaskDealModal.vue?vue&type=style&index=0&id=32cf45b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf45b5",
  null
  
)

export default component.exports